import { render } from "./reset-enrolments-confirmation-modal.vue?vue&type=template&id=5db89112&ts=true"
import script from "./reset-enrolments-confirmation-modal.ts?vue&type=script&lang=ts&external"
export * from "./reset-enrolments-confirmation-modal.ts?vue&type=script&lang=ts&external"

import "./reset-enrolments-confirmation-modal.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__